/**
 * @file The identity create reducer.
 */

import {
  IDENTITY_CREATE_REQUEST,
  IDENTITY_CREATE_SUCCESS,
  IDENTITY_CREATE_FAILURE,
  IDENTITY_CREATE_RESET,
} from '../actions/identity-create';

const initialState = {
  loading: false,
  error: '',
  success: false,
};

const identityCreateReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case IDENTITY_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        success: false,
      };

    case IDENTITY_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: true,
      };

    case IDENTITY_CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        success: false,
      };

    case IDENTITY_CREATE_RESET:
      return initialState;

    default:
      return state;
  }
};

export { initialState };
export default identityCreateReducer;
